import UserNoteList from './UserNoteList';

export const NoteConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path: '/user_note/list',
            component: UserNoteList
        },
    ]
};



// WEBPACK FOOTER //
// src/main/components/note/NoteConfig.js